import React from 'react';
import { connect } from 'react-redux';

import { Spacer, Flexer, Checkbox } from '@ontruck/orc';
import { getJobDetail, getJobDetailData } from 'redux/modules/job-detail/selectors';

import { HeaderStyled, FlexerParentMaxHeightStyled } from 'modules/detail/styled';
import { BackButton, CloseButton } from 'modules/detail/BackButton';

import { FormatPrice } from 'utils/format';

import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
  IdCell,
  LoadSummaryCell,
  WeightCell,
  HeightCell,
  ExtrasSummary,
} from 'modules/Common/Details';
import IsHandledBy from 'modules/journey/IsHandledBy';
import {
  DecaLink,
  getJourneyControlDocumentUrl,
  isControlDocumentAvailable,
  openControlDocument,
} from 'modules/journey/control-document';

import { reviewJob } from 'redux/modules/job-detail/effects';
import { IS_TENANT } from 'tenant/config';

import { downloadPdf } from 'utils/file';
import serialize from 'utils/serialize';
import * as http from 'utils/http';
import config from 'config';
import styled from 'styled-components';

const StyledLabel = styled.span`
  font-weight: 500;
  color: white;
  cursor: pointer;
`;

const HeaderSection = ({
  journey,
  reviewing,
  reviewJob,
  location,
  showCloseButton = false,
  showBackButton = true,
  closeURL = '',
  intl,
}) => {
  const { fromList, listScrollTop } = (location || {}).state || {};

  const backURL = `/jobs${fromList ? `/${fromList}` : ''}`;
  const t = intl?.messages.modules.header || {};

  const { stops = [] } = journey || {};
  const loadDropoff = stops[0]?.load_dropoff || [];
  const loadPickup = stops[0]?.load_pickup || [];
  const sealNumber = ([...loadPickup, ...loadDropoff].filter((load) => !!load.seal_number)[0] || {})
    .seal_number;
  const referenceNummber = (
    [...loadPickup, ...loadDropoff].filter((load) => !!load.reference_number)[0] || {}
  ).reference_number;

  //order pdf dowload function
  const handleOrderPdf = async () => {
    const lang = 'ES';
    const add_cancelled_wmark = undefined;
    const params = {
      lang,
      add_cancelled_wmark,
    };
    const response = await http.getBlob(
      `${config.BASE_URL}/v1/mercury/journeys/${journey?.id}/order_pdf/?${serialize(params)}`
    );
    downloadPdf(response, `order_${journey?.id}`);
  };

  //order Release / Aceptance (Entreguese y admitase) dowload function
  const handleReleaseAceptance = async () => {
    const orderId = journey?.shipper_orders[0]?.id;
    const url = `${config.BASE_URL}/v1/mercury/shipper_orders/${orderId}/release_acceptance_pdf/`;
    try {
      const response = await http.getBlob(url);
      downloadPdf(response, `Documento-puerto-${orderId}`);
    } catch (e) {
      alert(t.release_aceptance_not_available);
    }
  };

  const handleControlDocument = () =>
    openControlDocument(() => getJourneyControlDocumentUrl(journey?.id), t.deca_not_available);

  return (
    <HeaderStyled>
      <FlexerParentMaxHeightStyled alignItems="center">
        {showBackButton && (
          <BackButton
            text={t.go_back}
            to={{
              pathname: backURL,
              state: { fromDetail: true, listScrollTop },
            }}
          />
        )}
        {showCloseButton && (
          <CloseButton
            to={{
              pathname: closeURL,
            }}
          />
        )}
        {!!journey && (
          <>
            <Spacer mRight="M" mLeft="M">
              <IdCell id={journey.id} idType={'journey'} copiable />
            </Spacer>
            {IS_TENANT && (
              <Spacer mRight="M">
                <span>{journey.shipper_orders?.[0]?.logistics_operator_code}</span>
              </Spacer>
            )}
            <Spacer mRight="M">
              <LoadSummaryCell {...journey} showMax showEquivalents />
            </Spacer>
            {IS_TENANT && (
              <Spacer mRight="M">
                <span>{referenceNummber}</span>
              </Spacer>
            )}
            <Spacer mRight="M">
              <WeightCell {...journey} showMax />
            </Spacer>
            <Spacer mRight="M">
              {IS_TENANT ? (
                <span>
                  {t.seal_number} {sealNumber}
                </span>
              ) : (
                <HeightCell {...journey} showMax color="white" />
              )}
            </Spacer>
            <Spacer mRight="M">
              <ExtrasSummary
                {...journey}
                small
                config={{
                  additionalDocuments: {
                    show: false,
                  },
                }}
                color="white"
              />
            </Spacer>
            {!journey?.has_xdock_shipper_order && (
              <Spacer mRight="M">
                {t.margin} <FormatPrice value={journey.net_margin} currency={journey.currency} />
              </Spacer>
            )}
            <Spacer mRight="M">
              <Checkbox
                label={t.reviewed}
                size="M"
                checked={journey.is_reviewed}
                onChange={reviewJob}
                disabled={reviewing}
                dataE2E={'journey_detail__review'}
              />
            </Spacer>
            {isControlDocumentAvailable(journey.status) && (
              <Spacer mRight="M">
                <DecaLink
                  color="white"
                  onClick={handleControlDocument}
                  dataE2E="journey_detail__deca"
                />
              </Spacer>
            )}
            {IS_TENANT && (
              <Spacer mRight="M">
                <StyledLabel onClick={handleOrderPdf}>{t.doc_of_control}</StyledLabel>
              </Spacer>
            )}
            {IS_TENANT && (
              <Spacer mRight="M">
                <StyledLabel onClick={handleReleaseAceptance}>{t.release_aceptance}</StyledLabel>
              </Spacer>
            )}
          </>
        )}
      </FlexerParentMaxHeightStyled>
      {!!journey && (
        <Flexer.Child>
          <Spacer mRight="S">
            <IsHandledBy
              id={journey.id}
              handledBy={journey.handled_by}
              skin="light"
              showEditIcon
              allowEdit
            />
          </Spacer>
        </Flexer.Child>
      )}
    </HeaderStyled>
  );
};
export { HeaderSection };
export default connect(
  (state) => {
    const jobDetail = getJobDetail(state);
    const journey = getJobDetailData(state);
    return {
      journey,
      reviewing: jobDetail.reviewing,
    };
  },
  {
    reviewJob,
  }
)(withRouter(injectIntl(HeaderSection)));
